module.exports = __webpack_public_path__ + "img/蒙版分组 (1).816c9b88.png";